var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-6"},[(_vm.widthNow >= 550)?_c('Banner'):_c('BannerMobile'),(_vm.widthNow >= 550)?_c('MapCard'):_c('div',{staticStyle:{"margin-top":"2.5rem"}},[_c('MapCardMobile')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }